import React from 'react';
import SubMenuDropDownIcon from '../../../../../icons/SubMenuDropDownIcon';
import * as S from './style';
import { Link } from 'react-router-dom';

export default function MobileMenuLi({ menu, activeMenu, handleToggleMenu, isDefault }: any) {
  return (
    <S.MobileMenuLiContainer>
      <S.MobileMenuListComponent isActive={activeMenu === menu.title} isDefault={isDefault}>
        <Link to={menu.link}>{menu.title}</Link>
        {menu.dropdown && (
          <S.DropDownBtn
            isActive={menu.dropdown && activeMenu === menu.title}
            activeMenu={activeMenu}
            onClick={() => handleToggleMenu(menu.title)}
          >
            <SubMenuDropDownIcon isActive={activeMenu === menu.title} isDefault={isDefault} />
          </S.DropDownBtn>
        )}
      </S.MobileMenuListComponent>
      {menu.dropdown && activeMenu === menu.title && (
        <S.MobileSubMenu
          initial={{ maxHeight: 0, opacity: 0 }}
          animate={{ maxHeight: 500, opacity: 1 }}
          transition={{ duration: 0.5 }}
          isActive={activeMenu === menu.title}
        >
          {menu.subMenu.map((menu: any) => (
            <li>
              <Link to={menu.link}>{menu.title}</Link>
            </li>
          ))}
        </S.MobileSubMenu>
      )}
    </S.MobileMenuLiContainer>
  );
}
